import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  inject,
  Input,
  Output
} from '@angular/core';

@Directive({
  selector: '[idpClickOutside]',
  standalone: true
})
export class ClickOutsideDirective implements AfterViewInit {
  private hostEl = inject(ElementRef<HTMLElement>);

  @Output() appClickOutside = new EventEmitter<{ id: string }>();
  @Input() isMobile = false;
  @Input() APP_DISABLE_LEGACY = true;

  @HostListener('document:click', ['$event.target'])
  onClick(targetElement: EventTarget | null): void {
    if (!this.isValidClick(targetElement)) return;
    if (this.APP_DISABLE_LEGACY) return;
    if (this.isClickInsideNav(targetElement as HTMLElement)) return;
    this.appClickOutside.emit({ id: '' });
  }

  private isClickInsideNav(element: HTMLElement): boolean {
    const isInsideHost = this.hostEl.nativeElement.contains(element);
    const isOverlay = document.querySelector('.cdk-overlay-container');
    return isInsideHost || isOverlay;
  }

  ngAfterViewInit(): void {
    this.checkAppDisabledLegacy();
  }

  checkAppDisabledLegacy(): void {
    if (this.APP_DISABLE_LEGACY) {
      this.appClickOutside.emit({ id: 'book' });
    } else {
      this.appClickOutside.emit({ id: '' });
    }
  }

  private isValidClick(targetElement: EventTarget | null): boolean {
    return (
      !!targetElement && targetElement instanceof HTMLElement && !this.isMobile
    );
  }
}
